<template>
  <div>
    <div class="list">
      <div v-for="fileRequest in fileRequests" :key="fileRequest.id" class="row">
        <ts-checkbox
          class="checkbox"
          :value="isSelected(fileRequest)"
          @input="handleSelectionChange(fileRequest, $event)"
        ></ts-checkbox>
        <div class="file-info">
          <p class="file-name" v-text="fileRequest.name"></p>
          <p class="file-creation-info" v-text="fileRequest.description"></p>
        </div>
        <div class="files">
          <div class="platforms">
            <PlatformList :platforms="fileRequest.platforms" />
          </div>
        </div>
        <div class="actions">
          <ShareFileRequest
            :value="fileRequest"
            @copy="copy(fileRequest)"
            :url="createUrl(fileRequest.token)"
            @input="share"
            v-if="!fileRequest.archived"
          />
          <ts-button size="small" filled @click="archive(fileRequest)">
            <template v-if="fileRequest.archived"> Unarchive </template>
            <template v-else> Archive </template>
          </ts-button>
          <ts-button size="small" circle @click="copy(fileRequest)" v-if="!fileRequest.archived">
            <ts-icon icon="link" size="x-small" color="#6d7587" title="Copy link" />
          </ts-button>
          <template>
            <EditFileRequest group="delivery" :value="fileRequest" @input="onUpdate(fileRequest, $event)" />
          </template>
          <ts-button size="small" circle @click="onDelete(fileRequest)">
            <ts-icon icon="trash" size="x-small" color="#6d7587" title="Delete" />
          </ts-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditFileRequest from './EditFileRequest.vue';
import ShareFileRequest from './ShareFileRequest.vue';
import PlatformList from '@/components/PlatformList.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';
import { appId, config } from '@/api/workflow';

export default {
  mixins: [projectViewHelpers],
  components: { EditFileRequest, ShareFileRequest, PlatformList },
  props: {
    group: {
      type: String,
      default: 'assets'
    },
    label: {
      type: String,
      default: ''
    },
    fileRequests: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectedItems: [],
    appUrl: null
  }),
  methods: {
    createUrl(token) {
      return `${this.appUrl}/projects/${this.$store.state.workflow.currentProjectId}/file-requests/${token}`;
    },
    isSelected(target) {},
    handleSelectionChange(target) {},
    share(fileRequest) {
      this.$emit('archive', fileRequest);
    },
    async copy(fileRequest) {
      try {
        await this.$copyText(this.createUrl(fileRequest.token));
        this.showInfo('Link copied to clipboard');
      } catch (err) {
        console.error('Error when copying file request link', err);
        this.showError('Error when copying step link');
      }
    },
    onUpdate(oldValue, newValue) {
      this.$emit('update', newValue);
    },
    archive(fileRequest) {
      fileRequest.archived = !fileRequest.archived;
      this.$emit('update', fileRequest);
    },
    onDelete(fileRequest) {
      this.$emit('remove', fileRequest);
    }
  },
  async mounted() {
    this.appUrl = config('auth.appUrl');
  }
};
</script>

<style lang="scss" scoped>
.row {
  .platforms {
    flex-grow: 1;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 300px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
</style>